/* global FBAC */

import {
    templates_insights,
    templates_solutions,
    templates_news,
    templates_meta_autocomplete,
} from "./templates.js";

let corporateConciergeInstance = null;

export const initCorporateConcierge = () => {
    if (corporateConciergeInstance) {
        return corporateConciergeInstance;
    }

    if (typeof FBAC === "undefined" || !document.querySelector("#fbac")) {
        return null;
    }

    corporateConciergeInstance = new FBAC.default({
        input: "#query",
        inject: "#fbac",
        url: "https://wood-search.funnelback.squiz.cloud/s/suggest.json",
        showOnFront: 5,
        urlParts: {
            collection: "wood~sp-meta",
            show: 20,
            sort: 0,
        },
        highlight: true,
        loader: true,
        targetClass: {
            onOpen: "fbac__searched",
        },
        display: {
            headerOnNoResults: false,
            footerOnNoResults: false,
            scaffoldOnNoResults: false,
        },
        bindEvents: true,
        events: {
            afterFetch(query, data) {
                if (data.woodGlobal_insights && data.woodGlobal_insights.length) {
                    this.data.woodGlobal_insights = data.woodGlobal_insights.filter(
                        (res) => {
                            return (
                                res.disp &&
                                res.disp.listMetadata &&
                                res.disp.listMetadata.pageType[0] &&
                                res.disp.listMetadata.pageType[0] !== "Other"
                            );
                        }
                    );
                }

                if (data.woodGlobal_news && data.woodGlobal_news.length)
                    this.data.woodGlobal_news = data.woodGlobal_news.filter(
                        (res) => {
                            return (
                                res.disp &&
                                res.disp.listMetadata &&
                                res.disp.listMetadata.pageType[0] &&
                                res.disp.listMetadata.pageType[0] !== "Other"
                            );
                        }
                    );
                if (data.woodGlobal_solutions && data.woodGlobal_solutions.length)
                    this.data.woodGlobal_solutions =
                        data.woodGlobal_solutions.filter((res) => {
                            return (
                                res.disp &&
                                res.disp.listMetadata &&
                                res.disp.listMetadata.pageType[0] &&
                                res.disp.listMetadata.pageType[0] !== "Other"
                            );
                        });
            },
        },
        fb: [
            {
                id: "woodGlobal_insights",
                templates: templates_insights,
                urlParts: {
                    profile: "autocomplete_insights",
                },
            },
            {
                id: "woodGlobal_news",
                templates: templates_news,
                urlParts: {
                    profile: "autocomplete_news",
                },
            },
            {
                id: "woodGlobal_solutions",
                templates: templates_solutions,
                urlParts: {
                    profile: "autocomplete_solutions",
                },
            },
            {
                id: "woodGlobal_metaAutocomplete",
                templates: templates_meta_autocomplete,
                urlParts: {
                    collection: "wood~sp-combined-meta",
                    profile: "_default",
                    show: 3,
                },
            },
        ],
        scaffold(templates) {
            return `
            ${templates.woodGlobal_metaAutocomplete.results}
          <div class="fbac__all-results concierge__results">
            <div class="fbac__autocomplete">
            <div class="fbac__autocomplete--column">
                    <h3 class="title concierge__subtitle">Solutions</h3>
                    <ul>
                        ${templates.woodGlobal_solutions.results}
                    </ul>
                    ${templates.woodGlobal_solutions.noResults}
                </div>
                <div class="fbac__autocomplete--column">
                <h3 class="title concierge__subtitle">Insights</h3>
                    ${templates.woodGlobal_insights.results}
                    ${templates.woodGlobal_insights.noResults}
                </div>
                <div class="fbac__autocomplete--column">
                <h3 class="title concierge__subtitle">News</h3>
                    <ul>
                        ${templates.woodGlobal_news.results}
                    </ul>
                    ${templates.woodGlobal_news.noResults}
                </div>

            </div>
          </div>
        `;
        },
        globalTemplates: {
            header(query) {
                return `
                  <h2 class="concierge__title">${query}</h2>
                `;
            },
        },
    });

    corporateConciergeInstance.init();
    return corporateConciergeInstance;
};

export default initCorporateConcierge;
